import React, { useRef, useEffect, useState } from 'react';
import FormGroup from './FormGroup';
import { getImageById } from '../../api/imageApi';
import { useTranslation } from 'react-i18next';

export interface FormImageProps {
  label?: string;
  setFile: (file: File) => void;
  value?: string;
  testId?: string;
}

export default function FormImage({ label, setFile, value, testId }: FormImageProps) {
  const { t } = useTranslation();
  const inputFile = useRef<HTMLInputElement>(null);

  const [selectedFile, setSelectedFile] = useState<File | undefined>();
  const [preview, setPreview] = useState<string | undefined>();

  useEffect(() => {
    let objectUrl: string | undefined;
    if (selectedFile) {
      const binaryData: BlobPart[] = [selectedFile];
      objectUrl = window.URL.createObjectURL(
        new Blob(binaryData, { type: 'application/zip' })
      );
      setPreview(objectUrl);
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [selectedFile]);

  useEffect(() => {
    let objectUrl: string | undefined;
    if (value) {
      getImageById(value).then((blob: Blob) => {
        objectUrl = window.URL.createObjectURL(blob);
        setPreview(objectUrl);
      });
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [value]);

  const onButtonClick = () => {
    inputFile.current?.click();
  };

  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFile(file);
    }
  };

  return (
    <FormGroup label={label}>
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: 'none' }}
        onChange={onSelectFile}
        data-cy={testId}
      />
      <div
        style={{
          border: '2px solid black',
          width: '34px',
          height: '34px',
          cursor: 'pointer',
        }}
        onClick={onButtonClick}
      >
        {preview && (
          <img
            src={preview}
            alt={t('Upload')}
            style={{ width: '100%', height: '100%' }}
          />
        )}
      </div>
    </FormGroup>
  );
}
